import { asyncAction } from '@jarvis.oddle/core/tools/redux/action'
import { getAvailablePromotionsApi } from 'api/fesc/client'
import * as C from './constants'

export const fetchAvailablePromotionsAction = asyncAction({
  api: getAvailablePromotionsApi,
  requestAction: C.GET_AVAILABLE_PROMO_REQUEST,
  successAction: C.GET_AVAILABLE_PROMO_SUCCESS,
  failureAction: C.GET_AVAILABLE_PROMO_FAILURE
})
